import request from "@/utils/request";

export function indexRoles() {
  return request({
    url: "api/admin-panel/roles",
    method: "get"
  });
}

export function showRole(id) {
  return request({
    url: `api/admin-panel/roles/${id}`,
    method: "get"
  });
}

export function createRole(data) {
  return request({
    url: "api/admin-panel/roles",
    method: "post",
    data
  });
}

export function updateRole(data, id) {
  // data._method = "put";
  return request({
    url: `api/admin-panel/roles/${id}`,
    method: "put",
    data
  });
}
export function deleteRole(id) {
  return request({
    url: `api/admin-panel/roles/${id}`,
    method: "delete"
  });
}
